export default "__VITE_PUBLIC_ASSET__c1fe726d__"